export default __webpack_public_path__ + "static/media/admin-cursos-on.61bc3b3b.svg";